import { useLang } from '../i18n';
import SEO from '../components/SEO';
import { LineReveal, FadeIn, ParallaxImage } from '../components/motion';

const Azienda = () => {
  const { t } = useLang();
  const chapters = t('azienda.chapters');
  const zones = t('azienda.zones');

  return (
    <main data-testid="azienda-page">
      <SEO page="azienda" />
      <section className="pt-32 md:pt-44 pb-16 md:pb-24" data-testid="azienda-hero">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <FadeIn y={16} className="mb-8">
            <span className="inline-flex items-center gap-3 font-display text-xs uppercase tracking-[0.25em] font-bold text-secondary">
              <span className="w-10 h-px bg-secondary inline-block" />
              {t('azienda.eyebrow')}
            </span>
          </FadeIn>
          <LineReveal
            lines={[
              <span key="1">{t('azienda.heroTitle1')}</span>,
              <span key="2" className="font-serif italic font-light text-secondary">{t('azienda.heroTitle2')}</span>,
            ]}
            lineClassName="font-display font-extrabold text-[11vw] md:text-[8vw] leading-[0.9] tracking-tighter"
            className="mb-12"
          />
          <div className="grid lg:grid-cols-12 gap-10 items-end">
            <FadeIn delay={0.4} className="lg:col-span-4">
              <p className="text-base md:text-lg text-foreground/70 leading-relaxed" data-testid="azienda-hero-sub">{t('azienda.heroSub')}</p>
            </FadeIn>
            <FadeIn delay={0.5} className="lg:col-span-8">
              <div className="border border-foreground/10 overflow-hidden">
                <ParallaxImage src="/images/paq-stabilimento.webp" alt="Stabilimento PAQ Rovigo — rendering 3D" speed={0.08} className="aspect-[4/3] md:aspect-[16/9]" />
              </div>
            </FadeIn>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 border-t border-foreground/10" data-testid="manifesto-section">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <FadeIn className="mb-16">
            <span className="font-display text-xs uppercase tracking-[0.25em] font-bold text-secondary">{t('azienda.manifestoEyebrow')}</span>
          </FadeIn>
          <div>
            {chapters.map((c, i) => (
              <FadeIn key={c.n} delay={0.05} className="grid md:grid-cols-12 gap-6 md:gap-10 py-12 md:py-16 border-t border-foreground/10 first:border-t-0 first:pt-0">
                <div className="md:col-span-3">
                  <span className="font-serif italic font-light text-7xl md:text-8xl text-secondary/80 leading-none" data-testid={`chapter-number-${c.n}`}>{c.n}</span>
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-display font-extrabold text-3xl md:text-4xl tracking-tight" data-testid={`chapter-title-${c.n}`}>{c.t}</h3>
                </div>
                <div className="md:col-span-5 flex items-end">
                  <p className="text-foreground/70 leading-relaxed">{c.d}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      <section className="dark-section bg-[#111827] text-[#F7F5F0] noise-overlay py-24 md:py-32" data-testid="plant-section">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <FadeIn className="mb-14">
            <span className="font-display text-xs uppercase tracking-[0.25em] font-bold text-secondary">{t('azienda.plantEyebrow')}</span>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6" data-testid="plant-title">{t('azienda.plantTitle')}</h2>
          </FadeIn>
          <div className="grid grid-cols-2 lg:grid-cols-3 border-t border-l border-white/10">
            {zones.map((z, i) => (
              <FadeIn key={i} delay={i * 0.08} className="border-b border-r border-white/10 p-6 md:p-10 group hover:bg-white/5 transition-colors duration-500">
                <span className="font-display text-xs font-bold text-secondary tracking-widest">{String(i + 1).padStart(2, '0')}</span>
                <h3 className="font-display font-bold text-xl md:text-2xl tracking-tight mt-3 mb-2" data-testid={`zone-title-${i}`}>{z.t}</h3>
                <p className="text-sm text-white/50 leading-relaxed">{z.d}</p>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Azienda;
